<template>
  <div class="-mx-[1.5rem] mt-[16px]">
    <b-table
      :items="dataFetcher.data"
      :fields="UPGRADE_STATUS_FIELDS"
      :empty-text="emptyTextLabel"
      responsive
      show-empty
      small
      sticky-header
      class="!max-h-[calc(100vh-270px)] !mb-0"
      :tbody-tr-class="{'hover:bg-slate-100 transition-colors duration-300 cursor-pointer': dataFetcher.data.length}"
      @row-clicked="openDrawer"
    >
      <template #cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(name)="{ item: { name, tiktok_username } }">
        <div class="flex flex-col gap-[10px]">
          <span class="flex items-center gap-[4px]">
            {{ name || '-' }}
          </span>
          <span class="text-[12px] text-[#828282]">{{ tiktok_username || '-' }}</span>
        </div>
      </template>
      <template #cell(category)="{ item: { category } }">
        <category-pill :category="category" />
      </template>
      <template #custom-foot>
        <td colspan="100%">
          <load-more-data
            v-if="dataFetcher"
            :fetcher="dataFetcher"
          />
        </td>
      </template>
      <template #cell(status)="{ item }">
        <status-cell
          :data="item"
          :modal-upgrade-confirmation="$refs.modalUpgradeConfirmation"
        />
      </template>
      <template #empty="{emptyText}">
        <empty-table-card
          :fetcher="dataFetcher"
          :label="emptyText"
        />
      </template>
    </b-table>
    <member-drawer ref="memberDrawer" />
    <modal-upgrade-confirmation
      ref="modalUpgradeConfirmation"
    />
  </div>
</template>

<script>
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { DAY_MONTH_YEAR } from '@/libs/filterDate'
import { UPGRADE_STATUS_FIELDS } from '../config'
import MemberDrawer from '../../member/components/MemberDrawer.vue'
import LoadMoreData from '../LoadMoreData.vue'
import StatusCell from './StatusCell.vue'
import ModalUpgradeConfirmation from './ModalUpgradeConfirmation.vue'
import EmptyTableCard from '../EmptyTableCard.vue'
import CategoryPill from '../CategoryPill.vue'
import { parseAge, parsePhone } from '../utils'

export default {
  name: 'TableComponent',
  components: {
    MemberDrawer,
    LoadMoreData,
    StatusCell,
    ModalUpgradeConfirmation,
    EmptyTableCard,
    CategoryPill,
  },
  props: {
    filter: {
      type: Object,
      default: () => ({
        keyword: '',
        category: [],
      }),
    },
  },
  data() {
    return {
      dataFetcher: null,
      UPGRADE_STATUS_FIELDS,
    }
  },
  computed: {
    emptyTextLabel() {
      if (this.dataFetcher.isLoading) return 'Memuat data...'
      if (this.dataFetcher.error) return 'Terdapat kesalahan saat memuat data'
      return 'Tidak ada data yang ditampilkan.'
    },
  },
  created() {
    this.initializeFetcher()
  },
  mounted() {
    this.dataFetcher.fetchData({
      reset: true,
      options: {
        category: this.filter.category,
        keyword: this.filter.keyword,
      },
    })
  },
  methods: {
    /** Inisialisasi paginated fetcher untuk daftar upgrade status */
    initializeFetcher() {
      const fnFetch = ({
        offset, limit, category, keyword,
      }) => this.$http_new.get('/komclass/api/v1/komlabs/creators/upgrade-status', {
        params: {
          offset,
          limit,
          category: category?.length ? category.join(',') : undefined,
          search: keyword || undefined,
        },
      }).then(res => {
        const { creators } = res.data.data
        return {
          data: creators,
        }
      }).catch(() => {
        if (this.dataFetcher.offset === 0) {
          throw new Error('Gagal memuat data')
        }
        return {
          data: [],
        }
      })

      this.dataFetcher = createPaginatedFetcher(fnFetch, 0, 20)
    },
    /**
     * Reset dan muat ulang data tabel dengan filter baru
     * @param {{ category?: string[], keyword?: string }} params
     */
    refreshData({
      category, keyword,
    }) {
      this.dataFetcher.fetchData({
        reset: true,
        options: {
          category,
          keyword,
        },
      })
    },
    /**
     * Buka drawer detail kreator
     * @param {{ id: number|string }} item
     */
    openDrawer(item) {
      const mapper = data => ({
        'Data Diri': {
          Nama: data.name,
          Email: data.email,
          'No HP': parsePhone(data.phone),
          'Link Sosmed': data.tiktok_username ? `https://www.tiktok.com/@${data.tiktok_username}` : '-',
          Kategori: data.category?.join(', '),
          'Tanggal Register': DAY_MONTH_YEAR(data.register_date),
        },
        'Lain-lain': {
          'GMV 30 hari terakhir': data.gmv_30_days,
          'Jumlah Followers': data.followers_count,
          Domisili: data.domicile || '-',
          Gender: data.gender || '-',
          Usia: parseAge(data.age),
          'Tertarik menjadi anggota MCN Komlabs?': data.mcn_interest || '-',
        },
      })
      this.$refs.memberDrawer.openDrawer(item.id, mapper)
    },
  },
}
</script>
